import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "mt-15px grid grid-cols-1 gap-2"
};
const _hoisted_2 = {
  class: "flex items-center min-w-[200px] mr-10px"
};
const _hoisted_3 = {
  class: "text-[13px] text-[#303133] break-all"
};
const _hoisted_4 = {
  class: "flex-1"
};
const _hoisted_5 = {
  class: "ml-10px text-[13px] text-[#606266]"
};
const _hoisted_6 = {
  class: "flex justify-end mt-20px"
};
import { KnowledgeSegmentApi } from '@/api/ai/knowledge/segment';
import { computed, inject, onBeforeUnmount, onMounted, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ProcessStep',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const parent = inject('parent');
    const pollingTimer = ref(null); // 轮询定时器 ID，用于跟踪和清除轮询进程
    /** 判断文件处理是否完成 */
    const isProcessComplete = file => {
      return file.progress === 100;
    };
    /** 判断所有文件是否都处理完成 */
    const allProcessComplete = computed(() => {
      return props.modelValue.list.every(file => isProcessComplete(file));
    });
    /** 完成按钮点击事件处理 */
    const handleComplete = () => {
      if (parent?.exposed?.handleBack) {
        parent.exposed.handleBack();
      }
    };
    /** 获取文件处理进度 */
    const getProcessList = async () => {
      try {
        // 1. 调用 API 获取处理进度
        const documentIds = props.modelValue.list.filter(item => item.id).map(item => item.id);
        if (documentIds.length === 0) {
          return;
        }
        const result = await KnowledgeSegmentApi.getKnowledgeSegmentProcessList(documentIds);
        // 2.1更新进度
        const updatedList = props.modelValue.list.map(file => {
          const processInfo = result.find(item => item.documentId === file.id);
          if (processInfo) {
            // 计算进度百分比：已嵌入数量 / 总数量 * 100
            const progress = processInfo.embeddingCount && processInfo.count ? Math.floor(processInfo.embeddingCount / processInfo.count * 100) : 0;
            return {
              ...file,
              progress: progress,
              count: processInfo.count || 0
            };
          }
          return file;
        });
        // 2.2 更新数据
        emit('update:modelValue', {
          ...props.modelValue,
          list: updatedList
        });
        // 3. 如果未完成，继续轮询
        if (!updatedList.every(file => isProcessComplete(file))) {
          pollingTimer.value = window.setTimeout(getProcessList, 3000);
        }
      } catch (error) {
        // 出错后也继续轮询
        console.error('获取处理进度失败:', error);
        pollingTimer.value = window.setTimeout(getProcessList, 5000);
      }
    };
    /** 组件挂载时开始轮询 */
    onMounted(() => {
      // 1. 初始化进度为 0
      const initialList = props.modelValue.list.map(file => ({
        ...file,
        progress: 0
      }));
      emit('update:modelValue', {
        ...props.modelValue,
        list: initialList
      });
      // 2. 开始轮询获取进度
      getProcessList();
    });
    /** 组件卸载前清除轮询 */
    onBeforeUnmount(() => {
      // 1. 清除定时器
      if (pollingTimer.value) {
        clearTimeout(pollingTimer.value);
        pollingTimer.value = null;
      }
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue.list, (file, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex items-center py-4px px-12px border-l-4 border-l-[#409eff] rounded-sm shadow-sm hover:bg-[#ecf5ff] transition-all duration-300"
        }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Icon, {
          icon: "ep:document",
          class: "mr-8px text-[#409eff]"
        }), _createElementVNode("span", _hoisted_3, _toDisplayString(file.name), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_progress, {
          percentage: file.progress || 0,
          "stroke-width": 10,
          status: isProcessComplete(file) ? 'success' : ''
        }, null, 8, ["percentage", "status"])]), _createElementVNode("div", _hoisted_5, " 分段数量：" + _toDisplayString(file.count ? file.count : '-'), 1)]);
      }), 128))]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        type: allProcessComplete.value ? 'success' : 'primary',
        disabled: !allProcessComplete.value,
        onClick: handleComplete
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" 完成 ")])),
        _: 1
      }, 8, ["type", "disabled"])])]);
    };
  }
});